<!-- 通用配置-->
<template>
  <div>
    <!-- 折叠公共配置 -->
    <el-collapse accordion>
      <!-- 标题设置 -->
      <template v-if="main.vaildProp('titleList')">
        <el-collapse-item title="标题设置">
          <el-form-item label="标题">
            <avue-switch v-model="main.activeOption.titleShow"></avue-switch>
          </el-form-item>
          <el-form-item label="标题">
            <avue-input v-model="main.activeOption.title"></avue-input>
          </el-form-item>
          <el-form-item label="字体颜色">
            <avue-input-color v-model="main.activeOption.titleColor"></avue-input-color>
          </el-form-item>
          <el-form-item label="字体大小">
            <avue-input-number v-model="main.activeOption.titleFontSize"></avue-input-number>
          </el-form-item>
          <el-form-item label="标题字体">
            <avue-select v-model="main.activeOption.titleFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
          <el-form-item label="字体位置">
            <avue-select v-model="main.activeOption.titlePostion"
                         :dic="dicOption.textAlign">
            </avue-select>
          </el-form-item>
          <el-form-item label="副标题">
            <avue-input v-model="main.activeOption.subtext"></avue-input>
          </el-form-item>
          <el-form-item label="字体颜色">
            <avue-input-color v-model="main.activeOption.subTitleColor"></avue-input-color>
          </el-form-item>
          <el-form-item label="字体大小">
            <avue-input-number v-model="main.activeOption.subTitleFontSize">
            </avue-input-number>
          </el-form-item>
          <el-form-item label="副标题字体">
            <avue-select v-model="main.activeOption.subTitleFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
        </el-collapse-item>
      </template>
      <!-- 轴设置 -->
      <template v-if="main.vaildProp('barList')">
        <el-collapse-item title="X轴设置">
          <el-form-item label="名称">
            <avue-input v-model="main.activeOption.xAxisName">
            </avue-input>
          </el-form-item>
          <el-form-item label="显示">
            <avue-switch v-model="main.activeOption.xAxisShow">
            </avue-switch>
          </el-form-item>
          <el-form-item v-if="main.activeOption.linePreset !== 'tech'" label="显示网格线">
            <avue-switch v-model="main.activeOption.xAxisSplitLineShow">
            </avue-switch>
          </el-form-item>
          <el-form-item v-if="lineChart" label="首尾排列">
            <el-select :value="lineAxisSpacing" :disabled="main.activeLayoutLocked" aria-label="折线图X轴排列" @input="setLineAxisSpacing">
              <el-option label="沿用当前样式" value="default" />
              <el-option label="贴边显示" value="edge" />
              <el-option label="首尾留白" value="band" />
            </el-select>
          </el-form-item>
          <line-axis-options v-if="lineChart" />
          <el-form-item v-if="!lineChart" label="标签间距">
            <avue-switch v-model="main.activeOption.xAxisinterval">
            </avue-switch>
          </el-form-item>
          <el-form-item v-if="!lineChart" label="文字角度">
            <avue-switch v-model="main.activeOption.xAxisRotate">
            </avue-switch>
          </el-form-item>
          <el-form-item label="轴反转">
            <avue-switch v-model="main.activeOption.xAxisInverse">
            </avue-switch>
          </el-form-item>
          <el-form-item label="字号">
            <avue-input-number v-model="main.activeOption.xNameFontSize">
            </avue-input-number>
          </el-form-item>
          <el-form-item label="字体">
            <avue-select v-model="main.activeOption.xNameFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Y轴设置">
          <el-form-item label="名称">
            <avue-input v-model="main.activeOption.yAxisName">
            </avue-input>
          </el-form-item>
          <el-form-item label="显示">
            <avue-switch v-model="main.activeOption.yAxisShow">
            </avue-switch>
          </el-form-item>
          <el-form-item v-if="main.activeOption.linePreset !== 'tech'" label="轴网格线">
            <avue-switch v-model="main.activeOption.yAxisSplitLineShow">
            </avue-switch>
          </el-form-item>
          <el-form-item label="反转">
            <avue-switch v-model="main.activeOption.yAxisInverse">
            </avue-switch>
          </el-form-item>
          <el-form-item label="字号">
            <avue-input-number v-model="main.activeOption.yNameFontSize">
            </avue-input-number>
          </el-form-item>
          <el-form-item label="字体">
            <avue-select v-model="main.activeOption.yNameFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
        </el-collapse-item>
      </template>
      <!-- 数值设置 -->
      <template v-if="main.vaildProp('labelList')">
        <el-collapse-item title="数值设置">
          <el-form-item label="显示">
            <avue-switch v-model="main.activeOption.labelShow">
            </avue-switch>
          </el-form-item>
          <el-form-item label="字体大小">
            <avue-input-number v-model="main.activeOption.labelShowFontSize">
            </avue-input-number>
          </el-form-item>
          <el-form-item label="文字字体">
            <avue-select v-model="main.activeOption.labelShowFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
          <el-form-item label="字体颜色">
            <avue-input-color v-model="main.activeOption.labelShowColor">
            </avue-input-color>
          </el-form-item>
          <el-form-item label="字体粗细">
            <avue-select v-model="main.activeOption.labelShowFontWeight"
                         :dic="dicOption.fontWeight">
            </avue-select>
          </el-form-item>
        </el-collapse-item>
      </template>
      <!-- 提示语设置  -->
      <template v-if="main.vaildProp('tipList')">
        <el-collapse-item title="提示语设置">
          <el-form-item label="字体大小">
            <avue-input-number v-model="main.activeOption.tipFontSize"></avue-input-number>
          </el-form-item>
          <el-form-item label="文字字体">
            <avue-select v-model="main.activeOption.tipFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
          <el-form-item label="字体颜色">
            <avue-input-color v-model="main.activeOption.tipColor"></avue-input-color>
          </el-form-item>
        </el-collapse-item>
      </template>
      <!-- 轴距离设置 -->
      <template v-if="main.vaildProp('postionList')">
        <el-collapse-item title="坐标轴边距设置">
          <el-form-item v-if="cartesian" label="边距模式">
            <el-select :value="paddingMode" aria-label="图表边距模式" @input="$set(main.activeOption, 'chartPaddingMode', $event)">
              <el-option label="自动紧凑" value="auto" />
              <el-option label="手动设置" value="manual" />
            </el-select>
          </el-form-item>
          <p v-if="cartesian && paddingMode === 'auto'" class="chart-layout-help">按坐标文字、单位和数值自动留白；需要固定边距时切换手动设置。高级绘图区配置优先。</p>
          <template v-if="!cartesian || paddingMode === 'manual'">
          <el-form-item label="左边距(像素)">
            <avue-slider v-model="main.activeOption.gridX"
                         :max="400"></avue-slider>
          </el-form-item>
          <el-form-item label="顶边距(像素)">
            <avue-slider v-model="main.activeOption.gridY"
                         :max="400"></avue-slider>
          </el-form-item>
          <el-form-item label="右边距(像素)">
            <avue-slider v-model="main.activeOption.gridX2"
                         :max="400"></avue-slider>
          </el-form-item>
          <el-form-item label="底边距(像素)">
            <avue-slider v-model="main.activeOption.gridY2"
                         :max="400"></avue-slider>
          </el-form-item>
          </template>
        </el-collapse-item>
      </template>
      <!-- 图例设置 -->
      <template v-if="main.vaildProp('legendList')">
        <el-collapse-item title="图例操作">
          <el-form-item label="图例">
            <avue-switch v-model="main.activeOption.legend"></avue-switch>
          </el-form-item>
          <el-form-item label="位置">
            <avue-select v-model="main.activeOption.legendPostion"
                         :dic="dicOption.textAlign">
            </avue-select>
          </el-form-item>
          <el-form-item label="布局朝向">
            <avue-select v-model="main.activeOption.legendOrient"
                         :dic="dicOption.orientList">
            </avue-select>
          </el-form-item>
          <el-form-item label="字体大小">
            <avue-input-number v-model="main.activeOption.legendFontSize">
            </avue-input-number>
          </el-form-item>
          <el-form-item label="文字字体">
            <avue-select v-model="main.activeOption.legendFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
        </el-collapse-item>
      </template>
      <!-- 颜色设置 -->
      <template v-if="main.vaildProp('colorList') && main.activeOption.linePreset !== 'tech'">
        <el-collapse-item title="自定义配色">
          <el-form-item label="文字颜色">
            <avue-input-color v-model="main.activeOption.nameColor">
            </avue-input-color>
          </el-form-item>
          <el-form-item label="轴线颜色">
            <avue-input-color v-model="main.activeOption.lineColor"></avue-input-color>
          </el-form-item>
          <avue-crud :option="colorOption"
                     :data="main.activeOption.barColor"
                     @row-save="rowSave"
                     @row-del="rowDel"
                     @row-update="rowUpdate"></avue-crud>
        </el-collapse-item>
      </template>
      <template v-if="main.vaildProp('familyList') && main.activeOption.gaugeStyle !== 'tech'">
        <el-collapse-item title="自定义配色">
          <el-form-item label="文字颜色">
            <avue-input-color v-model="main.activeOption.valueFontColor">
            </avue-input-color>
          </el-form-item>
          <el-form-item label="字体">
            <avue-select v-model="main.activeOption.valueFontFamily"
                         :dic="dicOption.fontFamily">
            </avue-select>
          </el-form-item>
          <el-form-item label="轴线颜色">
            <avue-input-color v-model="main.activeOption.lineColor"></avue-input-color>
          </el-form-item>
          <avue-crud :option="colorOption"
                     :data="main.activeOption.barColor"
                     @row-save="rowSave"
                     @row-del="rowDel"
                     @row-update="rowUpdate"></avue-crud>
        </el-collapse-item>
      </template>
    </el-collapse>
  </div>
</template>

<script>
import { dicOption, colorOption } from '@/option/config'
import LineAxisOptions from './line-axis.vue'
export default {
  inject: ["main"],
  components: { LineAxisOptions },
  data () {
    return {
      dicOption: dicOption,
      colorOption: colorOption
    }
  },
  computed: {
    lineChart () { return (this.main.activeObj.component || {}).prop === 'line' },
    lineAxisSpacing () { return typeof this.main.activeOption.lineBoundaryGap === 'boolean' ? this.main.activeOption.lineBoundaryGap ? 'band' : 'edge' : 'default' },
    cartesian () { return ['bar', 'line'].includes((this.main.activeObj.component || {}).prop) },
    paddingMode () { return this.main.activeOption.chartPaddingMode === 'manual' ? 'manual' : 'auto' }
  },
  methods: {
    setLineAxisSpacing (value) {
      if (this.main.activeLayoutLocked) return
      if (value === 'default') this.$delete(this.main.activeOption, 'lineBoundaryGap')
      else if (['edge', 'band'].includes(value)) this.$set(this.main.activeOption, 'lineBoundaryGap', value === 'band')
    },
    rowSave (row, done) {
      this.main.activeOption.barColor.push(row);
      done()
    },
    rowDel (row, index) {
      this.main.activeOption.barColor.splice(index, 1);
    },
    rowUpdate (row, index, done) {
      this.main.activeOption.barColor.splice(index, 1, row);
      done()
    },
  }
}
</script>

<style scoped>
.chart-layout-help { margin: 4px 0 12px; color: var(--editor-muted, #a4b6c5); font-size: 12px; line-height: 1.6; }
</style>
